import { render, staticRenderFns } from "./addClientele.vue?vue&type=template&id=7cb48ab4&scoped=true&"
import script from "./addClientele.vue?vue&type=script&lang=ts&"
export * from "./addClientele.vue?vue&type=script&lang=ts&"
import style0 from "./addClientele.vue?vue&type=style&index=0&id=7cb48ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb48ab4",
  null
  
)

export default component.exports